import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseAvailableAuctionsProps<T> = {
  filters?: { page?: number }
  mapper?: (data: any) => T
}

export const useAvailableAuctions = <T,>({
  filters: { page } = {},
  mapper = Mapper.default<T>(),
}: UseAvailableAuctionsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['maintenanceAuctionsAvailable', page],
    queryFn: () =>
      privateAxios.get('/maintenance/establishment_choice/auction_entries/available_to_join', {
        params: { page },
      }),
    select: (response: { data: { data: any[]; meta: MetaResponse } }) => ({
      data: mapper(response?.data?.data),
      meta: response?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
